export enum UliStatus {
  Init = 'INIT',
  Registered = 'REGISTERED',
  CalledToDock = 'CALLED_TO_DOCK',
  CalledToWaitingArea = 'CALLED_TO_WAITING_AREA',
  Processed = 'PROCESSED',
  Loaded = 'LOADED',
  Loading = 'LOADING',
  Unloaded = 'UNLOADED',
  Unloading = 'UNLOADING',
  Deleted = 'DELETED',
  Cleared = 'CLEARED',
  Geofence1 = 'GEOFENCE1',
  Geofence2 = 'GEOFENCE2',
}

export enum UliActivityType {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
}

export enum TruckStatus {
  Init = 'INIT',
  Left = 'LEFT',
  WaitingArea = 'WAITING_AREA',
  Registered = 'REGISTERED',
  CalledToDock = 'CALLED_TO_DOCK',
  CalledToArrivalSecurity = 'CALLED_TO_ARRIVAL_SECURITY',
  ArrivalSecurityFinished = 'ARRIVAL_SECURITY_FINISHED',
  ArrivedAtDock = 'ARRIVED_AT_DOCK',
  ReleasedFromDock = 'RELEASED_FROM_DOCK',
  CalledToSealPictureControl = 'CALLED_TO_SEAL_PICTURE_CONTROL',
  SealPictureControlFinished = 'SEAL_PICTURE_CONTROL_FINISHED',
  DepartureSecurityFinished = 'DEPARTURE_SECURITY_FINISHED',
  PreparedForDeparture = 'PREPARED_FOR_DEPARTURE',
  Departed = 'DEPARTED',
  Geofence1 = 'GEOFENCE1',
  Geofence2 = 'GEOFENCE2',
  CalledToWaitingArea = 'CALLED_TO_WAITING_AREA',
}

export enum UliOrigin {
  WebApp = 'WEB_APP',
  GateApp = 'GATE_APP',
  EdiManager = 'EDI_MANAGER',
  TMSEurolog = 'TMS_EUROLOG',
  Erp = 'ERP',
  Srt = 'SRT',
}

export const customAcronymTooltips = {
  ['TMS_INET']: 'TMS INET',
};
export const ULI_ORIGIN_UI_TITLE_BY_ORIGIN = {
  [UliOrigin.EdiManager]: 'TMS_INET',
};

export enum PartyAddress {
  Delivery = 'deliveryPartyAddress',
  Pickup = 'pickupPartyAddress',
}

export enum UliTourType {
  TwoStopTour = 'twoStopTour',
  MultiStopTour = 'multiStopTour',
}

export enum UliCreationSteps {
  UliInformation = 'uliInformation',
  TruckInformation = 'truckInformation',
  DriverInformation = 'driverInformation',
  ContactData = 'contactData',
}

export enum UliRegistrationSteps {
  UliInformation = 'ulis',
  TruckInformation = 'truckInformation',
  TrailerHandling = 'trailerHandling',
  DriverInformation = 'driverInformation',
  Comments = 'comments',
  Signatures = 'signatures',
}

export enum FCMGoodsType {
  Others = 'OTHERS',
  Chemicals = 'CHEMICALS',
  RawMaterial = 'RAW_MATERIAL',
  FinishedGoods = 'FINISHED_GOODS',
  ScrappedGoods = 'SCRAPPED_GOODS',
}
